import axios from "axios";
import {
  CREATE_MESSAGES_FAIL,
  CREATE_MESSAGES_SUCCESS,
  GET_MESSAGES_FAIL,
  GET_MESSAGES_SUCCESS,
} from "./types";

export const getMessages = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(
        "http://localhost:5000/api/messages/sync"
      );
      dispatch({
        type: GET_MESSAGES_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: GET_MESSAGES_FAIL,
        payload: error.response ? error.response.data.message : error.message,
      });
    }
  };
};

export const createMessage = (message) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.post(
        "http://localhost:5000/api/messages/new",
        message,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      dispatch({
        type: CREATE_MESSAGES_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: CREATE_MESSAGES_FAIL,
        payload: error.response ? error.response.data.message : error.message,
      });
    }
  };
};
